import { Deserializable } from '../interfaces';

export class Balance implements Deserializable {
  importe: string | null;
  moneda: string | null;

  constructor() {
    this.importe = null;
    this.moneda = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
